import React, { useState } from 'react';
import { DateSelect, PickupContainer, Toast } from '../style';
import PropTypes from 'prop-types';
import 'react-datepicker/dist/react-datepicker.css';
import { Button } from '@design-system/Button';
import { Text } from '@design-system/Text';
import { TextArea } from '@design-system/TextArea';
import { Modal } from '@design-system/Modal/Modal';
import { AiOutlineClose } from 'react-icons/ai';
import { toast } from 'react-hot-toast';

const PickupAddress = ({
  partner_address,
  pickup_days,
  available_days,
  handlePickupDay,
  handlePickupNote,
  selected_pickupday,
}) => {
  const [error, setError] = useState('');
  const [isOpen, setOpen] = useState(false);
  const [note, setNote] = useState('');
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState('');

  const onChange = (date) => {
    let dateObject = new Date(date.target.value);
    const options = { weekday: 'long' };
    let selected_date = dateObject.toLocaleString('en-US', options);
    if (available_days.includes(selected_date)) {
      handlePickupDay(date.target.value);
      setSelected(selected_date);
      setError('');
      setShow(false);
    } else {
      setError(`${selected_date} is not an available pickup day`);
      setShow(true);
      handlePickupDay('');
      setSelected('');
    }
  };

  const handleSave = () => {
    handlePickupNote(note);
    toast.success('Pick up note added!!');
    setOpen(!open);
  };

  return (
    <>
      <Toast show={show || selected_pickupday === ''}>
        <div className="content">
          <div>{error || 'Selecte Pickup date'}</div>
          <div onClick={() => setShow(false)}>
            <AiOutlineClose
              color="#4F4F4F"
              size={15}
              style={{ cursor: 'pointer' }}
            />{' '}
          </div>
        </div>
      </Toast>

      <PickupContainer>
        <Modal show={isOpen} close={() => setOpen(!isOpen)}>
          <Text size="large" fs="20px" align="center">
            Pickup Note
          </Text>
          <TextArea
            placeholder="Pickup Note"
            row="5"
            onChange={(e) => setNote(e.target.value)}
          />
          <Button
            onClick={handleSave}
            bgColor="#549A9A"
            weight="500"
            text="Save"
            width="100%"
          />
        </Modal>
        <div className="header">
          pickup address
          <h4 onClick={() => setOpen(!isOpen)} style={{ whiteSpace: 'nowrap' }}>
            Add Pickup Note
          </h4>
        </div>

        <div className="body">
          {pickup_days?.length >= 1 ? (
            <div>
              <h4>Store Location</h4>
              <h5>{partner_address}</h5>
            </div>
          ) : null}

          <div>
            {pickup_days?.length >= 1 ? (
              <>
                <h4>Opening Hours</h4>
                <div className="pickup">
                  {pickup_days.map((data, idx) => (
                    <div className="days" key={idx}>
                      <h5>{data?.day}</h5>
                      <h5>
                        {data?.from} - {data?.to}
                      </h5>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <h6>
                Sorry, pickup option unavailable. Please choose delivery for doorstep
                service.
              </h6>
            )}
          </div>
        </div>
        {note && (
          <div className="pickup_note">
            <div className="card">
              <p>Pick up Note</p>
              <h3>{note}</h3>
            </div>
          </div>
        )}
      </PickupContainer>

      <DateSelect>
        <label htmlFor="date">Select pickup date</label>
        {selected !== '' && (
          <h3>You have selected {selected} as your pickup day!!</h3>
        )}
        <input type="date" id="date" name="date" onChange={onChange} />
      </DateSelect>
    </>
  );
};

export default PickupAddress;

PickupAddress.propTypes = {
  partner_address: PropTypes.string.isRequired,
  pickup_days: PropTypes.array.isRequired,
  available_days: PropTypes.array.isRequired,
  handlePickupDay: PropTypes.func.isRequired,
  handlePickupNote: PropTypes.func.isRequired,
  selected_pickupday: PropTypes.string.isRequired,
};
